// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2M9ud","container":"styles_container__3vixW","title":"styles_title__3uMet","wrapper":"styles_wrapper__17xT3","answer":"styles_answer__1z38t"};